import { render } from "./PlusExam.vue?vue&type=template&id=6520d2ba"
import script from "./PlusExam.vue?vue&type=script&lang=js"
export * from "./PlusExam.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__